import { createSelector } from '@reduxjs/toolkit';
import selfSelector from '../self';

const domainsFiltersSelector = createSelector(selfSelector, (domainsReport) => domainsReport.filter);

export default domainsFiltersSelector;
